// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WY6hi","col":"styles_col__3cCrf"};